// extracted by mini-css-extract-plugin
export var createdDate = "_n0-1";
export var divider = "_n0-2";
export var headerDivider = "_n0-3";
export var messagesCard = "_n0-0";
export var messagesContainer = "_n0-7";
export var messagesContainerWrapper = "_n0-4";
export var pointerCapturingButtonBoxes = "_n0-a";
export var showLeftPanelButton = "_n0-9";
export var showMoreButton = "_n0-c";
export var showMoreButtonContainer = "_n0-b";
export var summaryTitle = "_n0-6";
export var systemMessageCardWrapper = "_n0-d";
export var topButtons = "_n0-8";
export var withPadding = "_n0-5";